import { Container } from "reactstrap";
import TopNavbar from "./TopNavbar"; // Renamed for clarity
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <Container fluid className="p-0 min-vh-100 d-flex flex-column bg-light">
      {/* Universal Sticky/Top Navbar */}
      <TopNavbar />
      
      {/* Main Content Area sits cleanly underneath */}
      <main className="p-3 p-md-4 flex-grow-1">
        <Container>
          <Outlet />
        </Container>
      </main>
    </Container>
  );
};

export default AdminLayout;